import * as React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Actions / controls rendered on the right (desktop) or stacked below (mobile). */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Standard responsive page header used across the admin dashboard.
 * - Title + optional description on the left.
 * - Actions/controls stack full-width on mobile and align right on desktop.
 */
export function PageHeader({ title, description, children, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
        className
      )}
    >
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {children && (
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center sm:gap-3">
          {children}
        </div>
      )}
    </div>
  );
}
